import { render } from "./warningDetails2.vue?vue&type=template&id=8c979e04&scoped=true"
import script from "./warningDetails2.vue?vue&type=script&lang=js"
export * from "./warningDetails2.vue?vue&type=script&lang=js"

import "./warningDetails2.vue?vue&type=style&index=0&id=8c979e04&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\gitlab\\DemoLab\\DemoLab-data\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c979e04"]])

export default __exports__